// eslint-disable-next-line no-restricted-imports
import { ResponseMessage, ResponseMessageMsgTypeEnum } from '@eih-netbroker/api-order';

export type OrderResponseMessage = ResponseMessage;

export const ResponseMessageType = ResponseMessageMsgTypeEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ResponseMessageType = (typeof ResponseMessageType)[keyof typeof ResponseMessageType];
